module.exports = __webpack_public_path__ + "static/media/add_task.06cf547e.svg";